import {Chip} from "@mui/material";
import {styled} from "@mui/material/styles";

export const StatusChip = styled(Chip)(() => ({
    textTransform: 'capitalize',
    width: '6rem',
    height: '1.5rem',
    fontSize: '12px',
}));